var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h370 rdiv"},[_c('div',{staticClass:"h295"},[_c('v-tree',{ref:"tree",attrs:{"data":_vm.data,"halfcheck":true,"multiple":true,"selectAlone":true},on:{"node-check":_vm.getCheckedNodes}})],1),_vm._v(" "),_c('div',{staticClass:"clear"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fca053d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/byl/sys/role/treemenu2.vue
// module id = null
// module chunks = 